module.exports = __webpack_public_path__ + "8eca68289b3dedbf6835aa31cc79c8d1.svg";